
import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'ngWords';

export const LIST = createAsyncActionTypes(`${PREFIX}/LIST`);
export const CREATE = createAsyncActionTypes(`${PREFIX}/CREATE`);
export const BATCH_DELETE = createAsyncActionTypes(`${PREFIX}/BATCH_DELETE`);